import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { Placement } from "common/components/tooltip/types";
import { BoardsDashboardSelector } from "common/widgets/dashboard-selector/presets";
import { ButtonTheme } from "common/components/button/constants";
import { Directions } from "common/components/drop-menu/types";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    class: { "mp-boards-save-button": true }
  }, this.showSaveAsNew() && /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".save-as-new",
    attrs: {
      theme: this.attr(`can-save-existing`) ? ButtonTheme.Secondary : ButtonTheme.Primary,
      disabled: !this.isSaveAsNewEnabled(),
      tooltip: this.isSaveAsNewEnabled() && { text: `Save a duplicate of this report` }
    },
    on: { click: this.helpers.handleSaveAsNewButtonClicked }
  }, "Save As New"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".save",
    attrs: {
      icon: this.icon(),
      theme: this.attr(`can-save-existing`) ? ButtonTheme.Primary : ButtonTheme.Secondary,
      pressed: this.state.isOpen,
      disabled: !this.isSaveEnabled() || this.fiwFeatureEnabled() && this.attr(`show-save-spinner`),
      tooltip: this.attr(`tooltip`) ? { placement: Placement.Top, text: this.attr(`tooltip`) } : null
    },
    on: { click: this.helpers.handleSaveButtonClicked },
    class: { save: this.fiwFeatureEnabled() }
  }, this.attr(`has-unsaved-changes`) || this.attr(`is-saving`) ? `Save` : `Saved`), this.state.isOpen && /* @__PURE__ */ jsx(BoardsDashboardSelector, {
    recentDashboardIds: this.state.recentDashboardIds,
    placeholder: this.attr(`search-placeholder`),
    open: this.state.isOpen,
    direction: Directions.Down,
    dashboardController: this.dashboardController,
    handleDashboardSelected: this.helpers.handleDashboardSelected,
    handleMenuChanged: this.helpers.handleMenuChanged,
    alignRight: this.attr(`align-right`)
  }));
}
